import { render } from "./LifestageForm.vue?vue&type=template&id=049f7932&scoped=true"
import script from "./LifestageForm.vue?vue&type=script&lang=js"
export * from "./LifestageForm.vue?vue&type=script&lang=js"

import "./LifestageForm.vue?vue&type=style&index=0&id=049f7932&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049f7932"]])

export default __exports__